import { useEffect, useState } from "react";
import api from "../../lib/api";
import { Button } from "../../components/ui/button";
import { Switch } from "../../components/ui/switch";
import { Label } from "../../components/ui/label";
import { Save, Settings as SettingsIcon } from "lucide-react";
import { toast } from "sonner";

export default function AdminSettings() {
  const [settings, setSettings] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => { api.get("/admin/settings").then((r) => setSettings(r.data)); }, []);

  const save = async () => {
    setLoading(true);
    try {
      const r = await api.put("/admin/settings", settings);
      setSettings(r.data);
      toast.success("Ayarlar kaydedildi");
    } catch { toast.error("Hata"); }
    finally { setLoading(false); }
  };

  return (
    <div className="p-8 max-w-3xl" data-testid="admin-settings">
      <div className="flex items-center gap-3 mb-6">
        <SettingsIcon className="text-gold" size={24} />
        <h1 className="heading-serif text-3xl font-semibold text-navy">Site Ayarları</h1>
      </div>

      <div className="space-y-5">
        <div className="bg-white rounded-xl border border-gray-100 p-6">
          <h2 className="heading-serif font-semibold text-navy mb-4">Hesaplama Aracı</h2>
          <div className="flex items-start gap-4 p-4 bg-softbg rounded-md">
            <Switch
              checked={!!settings.use_custom_formulas_only}
              onCheckedChange={(v) => setSettings({ ...settings, use_custom_formulas_only: v })}
              data-testid="settings-custom-only-toggle"
            />
            <div className="flex-1">
              <Label className="text-sm font-medium text-navy">Sadece özel formülleri kullan</Label>
              <p className="text-xs text-gray-500 mt-1 leading-relaxed">
                Açıkken Ekipman Hesaplama aracı yalnızca Admin → Ekipman Formülleri sayfasında tanımladığınız
                formülleri kullanır; varsayılan kuralları (havlu, buklet, minibar vb.) tamamen devre dışı bırakır.
                Kapalıyken admin formülleri varsayılanları geçersiz kılar (yalnızca tanımlı oda tipleri için);
                tanımsız oda tiplerinde varsayılan kurallar çalışmaya devam eder.
              </p>
            </div>
          </div>
        </div>

        <Button onClick={save} disabled={loading} className="bg-gold hover:bg-[#c49d58]" data-testid="settings-save">
          <Save size={14} className="mr-1" /> {loading ? "Kaydediliyor..." : "Ayarları Kaydet"}
        </Button>
      </div>
    </div>
  );
}
